export default {
  MANTIS: 'MANTIS',
  P2P: 'P2P',
  TRANSITIONING: 'TRANSITIONING',
};
